import { useState } from "react";
import { LOGO_URL } from "@/lib/api";
import { Lock } from "lucide-react";

const VALID_CODES = ["2109", "1427"];

export default function PinLock({ onUnlock }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);

  const press = (d) => {
    if (pin.length >= 4) return;
    const next = pin + d;
    setPin(next);
    setError(false);
    if (next.length === 4) {
      setTimeout(() => {
        if (VALID_CODES.includes(next)) {
          onUnlock();
        } else {
          setError(true);
          setPin("");
        }
      }, 150);
    }
  };

  const clear = () => {
    setPin("");
    setError(false);
  };
  const back = () => setPin((p) => p.slice(0, -1));

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ backgroundColor: "#032352" }}
      data-testid="pin-lock-screen"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center">
        <img src={LOGO_URL} alt="J&L Industrial Supplies" className="w-28 h-28 object-contain mb-4" />
        <div className="flex items-center gap-2 text-[#5B5C5F] mb-1">
          <Lock className="w-4 h-4" />
          <span className="text-sm uppercase tracking-wider">Authorised access only</span>
        </div>
        <h1 className="font-heading text-xl font-bold text-[#032352] mb-6">Enter Access Code</h1>

        <div className="flex gap-3 mb-6" data-testid="pin-dots">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`w-4 h-4 rounded-full border-2 transition-all ${
                pin.length > i ? "bg-[#032352] border-[#032352]" : "border-[#5B5C5F]/40"
              } ${error ? "border-red-500" : ""}`}
            />
          ))}
        </div>
        {error && (
          <p className="text-red-500 text-sm mb-4" data-testid="pin-error">
            Incorrect code, try again
          </p>
        )}

        <div className="grid grid-cols-3 gap-3 w-full">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
            <button
              key={n}
              onClick={() => press(String(n))}
              data-testid={`pin-key-${n}`}
              className="h-16 rounded-lg text-2xl font-heading font-semibold text-[#032352] bg-slate-50 hover:bg-[#032352] hover:text-white transition-colors"
            >
              {n}
            </button>
          ))}
          <button
            onClick={clear}
            data-testid="pin-key-clear"
            className="h-16 rounded-lg text-sm font-medium text-[#5B5C5F] bg-slate-50 hover:bg-slate-200 transition-colors"
          >
            Clear
          </button>
          <button
            onClick={() => press("0")}
            data-testid="pin-key-0"
            className="h-16 rounded-lg text-2xl font-heading font-semibold text-[#032352] bg-slate-50 hover:bg-[#032352] hover:text-white transition-colors"
          >
            0
          </button>
          <button
            onClick={back}
            data-testid="pin-key-back"
            className="h-16 rounded-lg text-sm font-medium text-[#5B5C5F] bg-slate-50 hover:bg-slate-200 transition-colors"
          >
            ⌫
          </button>
        </div>
      </div>
      <p className="text-white/50 text-xs mt-6">J&amp;L Industrial Supplies · Invoicing</p>
    </div>
  );
}
